export default __webpack_public_path__ + "static/whyUsLogo-5b4234f06e503c26ab7cafacde9b99ce.svg";